import {useEffect, useRef, useState} from "react"
import {Card, Col, Row} from "react-bootstrap";
import {UsePatch, UsePut} from "../../hooks/http";
import {UseMessage} from "../../hooks/UseMessage";
import Select from "../../components/input/select";
import momentTZ from "moment-timezone";
import CardMenu from "../../components/card-menu";
import Menu from "./Menu";
import Alert from "../../components/alert";
import {timezone_info} from "../../config/tips";
import Text from "../../components/input/text";
import Button from "../../components/button";
import UseGetFormData from "../../hooks/UseGetFormData";
import {useEnterprise} from "./EnterpriseProvider";

const Settings = () => {
    const formRef = useRef()
    const [errors, setErrors] = useState()
    const {enterprise} = useEnterprise();
    const idEnterprise = enterprise?._id?.$oid;

    const [isLoading, setIsLoading] = useState(false)
    const EnterpriseMenu = Menu({id: idEnterprise})

    const handleUpdate = (ev) => {
        ev.preventDefault()
        setIsLoading(true)
        const FormData = UseGetFormData(formRef)

        const PostData = {
            timezone: FormData.get('timezone'),
            subdomain: FormData.get('subdomain')
        }

        UsePatch(
            `/enterprises/upsert/${idEnterprise}`,
            {data: PostData}
        ).then((response) => {
            window.setTimeout(() => {
                if (response.code >= 200 && response.code <= 299) {
                    UseMessage('success', 'Enteprise has been successfully updated')
                    setErrors(undefined)
                } else {
                    setErrors(response.errors)
                }
                setIsLoading(false)
            }, 1500)
        })
    }



    const getTimezones = () => {
        const timezones = []
        const timeZonesList = momentTZ.tz.names()
        timeZonesList.map((zone) => {
            timezones.push({label: zone, value: zone})
        })

        return timezones;
    }


    return (
        <>
            <Card>
                <Row>
                    <Col>
                        <div className="max-width-600">
                            <form ref={formRef} autoComplete="off" onSubmit={handleUpdate}>
                                <CardMenu {...EnterpriseMenu} />

                                <Alert
                                    icon="info"
                                    docsPath="/docs/enterprises"
                                    message={timezone_info}
                                />


                                <Select
                                    required
                                    name="timezone"
                                    label="Timezone"
                                    isReady={!isLoading}
                                    options={getTimezones()}
                                    error={errors?.timezone}
                                    value={enterprise?.timezone}
                                />


                                <Text
                                    required
                                    size="md"
                                    name="subdomain"
                                    label="Email Subdomain"
                                    isReady={!isLoading}
                                    suffix=".idnurt.com"
                                    error={errors?.subdomain}
                                    placeholder="Type subdomain..."
                                    value={enterprise?.subdomain}
                                />

                                <Button
                                    size="sm"
                                    icon="check"
                                    label="Update"
                                    color="primary"
                                    className="mt-2"
                                    isReady={!isLoading}
                                />
                            </form>
                        </div>
                    </Col>
                </Row>
            </Card>
        </>
    )
}

export default Settings